<template>
  <div class="hero">
    <div class="hero-top">
      <img src="./../assets/osnova-boja.png" alt="" />
      <h1>Da li ste zadovoljni izveštavanjem RTS – a?</h1>
    </div>
    <p class="website-desc">
      Ukoliko je Vaš odgovor NE, ovo je prilika da im zajedno stavimo do znanja
      razloge našeg nezadovoljstva.
    </p>
    <p class="website-desc">
      <b>
        Hajde da preko ove aplikacije zatrpamo mejlove RTS-a kako bi se čuo glas
        građana na javnom servisu koji svi mi plaćamo. Pratite uputsva i
        pošaljite im mejl preko ove aplikacije.
      </b>
    </p>
    <p class="website-desc">
      Poslali smo zahtev RTS-u da želimo da se na RTS-u povede javna raspravu o
      predlogu zakona o zabrani ekspolatacije bora i litijuma koji je podnelo
      38.000 građana.
    </p>
    <p class="website-desc">
      Ispred Vas se nalazi polje u koje je potrebno
      <b>upisati Vaše ime, prezime (možete i samo ime), ali i mail adresu. </b>
    </p>
    <p class="website-desc">
      Nakon toga
      <b>
        izaberite jednu od opcija za naslov, a naslov možete i sami menjati po
        sopstvenom nahođenju.
      </b>
    </p>
    <p class="website-desc">
      <b> Izborom jedne opcije birate tekst koji želite da pošaljete </b>
      a taj tekst takođe možete modifikovati ili napisati svojim rečima, što vas
      pozivamo da učinite! Napišite svoje mišljenje svojim rečima!
    </p>
    <p class="website-desc">
      Budite kreativni, bez uvreda, psovanja ili neprimerenih komentara. Naš
      cilj je da nas čuju, da zajedno, svako na svoj način objasni RTS–u
      <b
        >zašto je važno izveštavanje o problemu iskopavanja litijuma, zašto je
        Rio Tinto tema od javnog interesa?
      </b>
    </p>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
h1 {
  font-size: 2em;
  color: #182338;
  margin: 10px 0;
  font-weight: 900;
  /* text-align: justify; */
  max-width: 500px;
}
.website-desc {
  width: 100%;
  margin: 10px auto;
  max-width: 510px;
  text-align: justify;
  /* max-width: 50%; */
  font-size: 1.3em;
  /* font-size: 19px; */
}
.hero-top {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.hero-top img {
  width: 50px;
  height: 50px;
  margin: 10px 0;
}
.instructions {
  margin-top: 50px;
  font-weight: 600;
}
@media only screen and (max-width: 600px) {
  .website-desc {
    max-width: 90%;
    text-align: justify;
    font-size: 16px;
  }
}
</style>
